import React, { ReactNode } from "react";

interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  bgColor: string;
  textColor?: string; // Optional text color
}

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  bgColor,
  textColor = "text-white",

}) => {
  return (
    <div className="relative group">
      {children}
      <div
        className={`absolute hidden group-hover:flex z-10 bottom-full left-1/2 -translate-x-1/2 mb-3 px-3 py-2 text-xs ${textColor} ${bgColor} rounded-md shadow-lg whitespace-nowrap`}
      >
        {content}
        <div
          className={`absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-transparent ${bgColor.replace(
            "bg-",
            "border-t-"
          )}`}
        ></div>
      </div>
    </div>
  );
};
